<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header">
            <strong>Resumen de Compras-Gastos</strong>
          </div>
          <b-form>
            <b-form-group
              label="Fecha Desde"
              label-for="fechaDesde"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaDesde" 
                v-model="fechaDesde" 
                :state="fechaDesdeValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaDesdeFeedback">
                {{ fechaDesdeInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Fecha Hasta"
              label-for="fechaHasta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaHasta" 
                v-model="fechaHasta" 
                :state="fechaHastaValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaHastaFeedback">
                {{ fechaHastaInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Proveedor"
              label-for="proveedor"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarProveedor">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !proveedor,
                                  'fa fa-remove': proveedor  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="proveedor"
                  :value="proveedorNombre"
                  readonly
                  type="text"/>
              </b-input-group>
            </b-form-group>

            <app-opcion-reporte
              label="Tipo de Reporte"
              :labelCols="labelCols"
              :nombre="opcionReporteNombre"
              :lista="opcionesReporteList"
              @validate="validate"
              @updated="opcionReporteActualizado">
            </app-opcion-reporte>

            <b-form-group
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="transportes"
                  v-model="transportes"
                  :value="true"
                  :unchecked-value="false">
                  Sólo Transportes
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="presupuestosCerrados"
                  v-model="presupuestosCerrados"
                  :value="true"
                  :unchecked-value="false"
                  :disabled="!opcionPresupuestosHabilitada || reporteDevengado">
                  Sólo Compras Asociadas a Presupuestos Cerrados
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="reporteDevengado"
                  v-model="reporteDevengado"
                  :value="true"
                  :unchecked-value="false"
                  :disabled="presupuestosCerrados">
                  Consultar egresos realizados en el período
              </b-form-checkbox>
            </b-form-group>

            <small>En el caso de consulta de egresos, el reporte filtra por fecha de pago</small>  
          </b-form>

          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="exportXls">Exportar XLS</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="searchProveedorModal"
        title="Seleccionar Proveedor"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="search-modal">
      <app-search-proveedor
        :incluirInactivos="true"
        @proveedorSeleccionado="proveedorSeleccionado">
      </app-search-proveedor>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import SearchProveedor from '../proveedores/SearchList.vue';
import OpcionReporte from '../shared/abmSelect.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import export_xls_compras from '../../mixins/export_xls_compras';
import moment from 'moment';

export default {
  name: 'ABM',
  components: {
    appSearchProveedor: SearchProveedor,
    appOpcionReporte: OpcionReporte,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal,
    export_xls_compras
  ],
  data () {
    return {
      /* Validacion de datos */
      noValidar: true,
      fechaDesdeValida: null,
      fechaDesdeInvalidaMsj: '',
      fechaHastaValida: null,
      fechaHastaInvalidaMsj: '',

      fechaDesde: moment(new Date()).format('YYYY-MM-DD'),
      fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
      proveedor: null,
      transportes: false,
      opcionReporte: 1,
      opcionReporteNombre: 'Reporte de Compras-Gastos',
      presupuestosCerrados: false,
      reporteDevengado: false,

      opcionesReporte: [
        { id: 1, nombre: 'Reporte de Compras-Gastos'},
        { id: 2, nombre: 'Reporte de Compras'},
        { id: 3, nombre: 'Reporte de Gastos'},
      ],
      opcionesReporteList: [ 'Reporte de Compras-Gastos', 'Reporte de Compras', 'Reporte de Gastos' ],

      labelCols: 2,
    }
  },
  computed: {
    proveedorNombre() {
      return this.proveedor? this.proveedor.nombre.trim() : '';
    },
    opcionPresupuestosHabilitada() {
      if (this.opcionReporte) {
        return this.opcionReporte != 3;
      }
      return false;
    },
  },
  created() {
    
  },  
  methods: {
    validate() {
    },
    exportXls () {
      let execute = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let proveedorId = 0;
      if (this.proveedor) {
        proveedorId = this.proveedor.id;
      }

      let params = {
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
        proveedorId,
        transportes: (/true/i).test(this.transportes),
        opcionReporte: this.opcionReporte,
        presupuestosCerrados: (/true/i).test(this.presupuestosCerrados),
        reporteDevengado: (/true/i).test(this.reporteDevengado),
      }

      if (execute) {
        this.showSpinner();
        this.$store.dispatch('compras/getRptComprasGastos', params)
          .then(() => {
            let exportRpt = Boolean(false); 
            let rptCompras = this.$store.getters['compras/rptCompras'];

            if (rptCompras) {
              if (rptCompras.length != 0) {
                exportRpt = Boolean(true);
              }
            }
            if (exportRpt) {
              let title= 'Detalle de Compras-Gastos';
              let fileName = 'compras-gastos';
              if (this.opcionReporte == 2) {
                title= 'Detalle de Compras';
                fileName = 'compras';
              } else if (this.opcionReporte == 3) {
                title= 'Detalle de Gastos';
                fileName = 'gastos';
              }
              let format = [
                { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
                { titulo: 'Fecha Ingreso', nombre: 'fechaRegistro', formato: 'fecha' },
                { titulo: 'Fecha Comprobante', nombre: 'fechaComprobante', formato: 'fecha' },
                { titulo: 'Fecha Vencimiento', nombre: 'fechaVencimiento', formato: 'fecha' },
                { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
                { titulo: 'Moneda', nombre: 'moneda', formato: '' },
                { titulo: 'Total Comprobante Moneda Original', nombre: 'totalComprobante', formato: '' },
                { titulo: 'Total Comprobante Pesos', nombre: 'totalComprobantePesos', formato: '' },
                { titulo: 'Neto Comprobante', nombre: 'montoNetoComprobante', formato: '' },
              ];
              if (this.opcionReporte == 1 || this.opcionReporte == 3) {
                format.push({ titulo: 'Neto Gastos', nombre: 'montoNetoCuentasGastos', formato: '' });
              }
              if (this.opcionReporte == 1 || this.opcionReporte == 2) {
                // format.push({ titulo: 'Neto Gastos Producción', nombre: 'montoNetoCuentasProduccion', formato: '' });
                format.push({ titulo: 'Neto Ordenes Proveedores', nombre: 'montoNetoOrdenesProveedores', formato: '' });
              }
              if (this.opcionReporte == 1 || this.opcionReporte == 3) {
                format.push({ titulo: 'Neto Ordenes Internas', nombre: 'montoNetoOrdenesProveedoresInternas', formato: '' });
              }
              if (this.opcionReporte == 1 || this.opcionReporte == 2) {
                format.push({ titulo: 'Neto Remitos', nombre: 'montoNetoRemitos', formato: '' });
              }
              if (this.opcionReporte == 1 || this.opcionReporte == 3) {
                format.push({ titulo: 'Neto Remitos Internos', nombre: 'montoNetoRemitosInternos', formato: '' });
              }
              if (this.opcionReporte == 1 || this.opcionReporte == 2) {
                format.push({ titulo: 'Neto Viaticos', nombre: 'montoNetoViaticos', formato: '' });
              }
              format.push({ titulo: 'Cuenta', nombre: 'proveedorCuenta', formato: '' });
              if (this.opcionReporte == 1 || this.opcionReporte == 2) {
                format.push({ titulo: 'Presup.Internos', nombre: 'presupuestosInternos', formato: '' });
              }
              format.push({ titulo: 'Fecha/s Pago', nombre: 'fechaPago', formato: '' });
              format.push({ titulo: 'Plazo Pago Proveedor', nombre: 'proveedorPlazo', formato: '' });

              if ((/true/i).test(this.reporteDevengado)) {
                format.push({ titulo: 'Pje.Devengado', nombre: 'pjeDevengado', formato: '' });
                format.push({ titulo: 'Neto Devengado', nombre: 'montoNetoComprobanteDevengado', formato: '' });

                if (this.opcionReporte == 1 || this.opcionReporte == 3) {
                  format.push({ titulo: 'Neto Gastos Devengado', nombre: 'montoNetoCuentasGastosDevengado', formato: '' });
                }
                if (this.opcionReporte == 1 || this.opcionReporte == 2) {
                  // format.push({ titulo: 'Neto Gastos Producción Devengado', nombre: 'montoNetoCuentasProduccionDevengado', formato: '' });
                  format.push({ titulo: 'Neto Ordenes Proveedores Devengado', nombre: 'montoNetoOrdenesProveedoresDevengado', formato: '' });
                }
                if (this.opcionReporte == 1 || this.opcionReporte == 3) {
                  format.push({ titulo: 'Neto Ordenes Internas Devengado', nombre: 'montoNetoOrdenesProveedoresInternasDevengado', formato: '' });
                }
                if (this.opcionReporte == 1 || this.opcionReporte == 2) {
                  format.push({ titulo: 'Neto Remitos Devengado', nombre: 'montoNetoRemitosDevengado', formato: '' });
                }
                if (this.opcionReporte == 1 || this.opcionReporte == 3) {
                  format.push({ titulo: 'Neto Remitos Internos Devengado', nombre: 'montoNetoRemitosInternosDevengado', formato: '' });
                }
                if (this.opcionReporte == 1 || this.opcionReporte == 2) {
                  format.push({ titulo: 'Neto Viaticos Devengado', nombre: 'montoNetoViaticosDevengado', formato: '' });
                }
              }

              this.exportXLS(title, fileName, rptCompras, format);
            } else {
              this.showModalMsj('No hay datos para exportar', null, null, 'light');
            }
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    seleccionarProveedor() {
      if (this.proveedor) {
        this.proveedor = null;
      } else {
        this.$refs.searchProveedorModal.show();
      }
    },
    proveedorSeleccionado(item) {
      this.proveedor = item;
      this.$refs.searchProveedorModal.hide();
    },
    opcionReporteActualizado(opcionReporteNombre) {
      this.opcionReporte = 0;
      this.opcionReporteNombre = opcionReporteNombre;
      if (this.opcionReporteNombre) {
        let opcion = this.getSelected(this.opcionesReporte, this.opcionReporteNombre);

        if (opcion) {
          this.opcionReporte = opcion.id;
        }
      }
    }
  },
}
</script>

<style>
</style>
